import React, { useState } from "react";
import "./DeviationDayCard.css";
import {DeviationDayCardProps} from "./deviationDayCardTypes";
import EventNoteIcon from "@mui/icons-material/EventNote";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import nhTown from "./images/nhTown.png";
import startTown from "./images/startTown.png";
import workTown from "./images/workTown.png";
import meetingTown from "./images/meetingTown.png";
import { Box, Button, TextField } from "@mui/material";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { submitDeviationApprovalData } from "../../features/deviationApproval/DeviationApprovalService"

const DeviationDayCard: React.FC<DeviationDayCardProps> = ({PjpDayData, pjpPlanOption, fetchDeviationData}) => {
  
  const { translate } = usePortalTranslation();

  const [showDetails, setShowDetails] = useState<boolean>(false);

  const [managerComment, setManagerComment] = useState<string>("");
  const [error, setError] = useState<boolean>(false);


  
  const onCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setManagerComment(event.target.value);
    if (event.target.value.trim()) {
      setError(false);
    }
  };


  const handleApprove = async (action: "approve" | "reject") => {
    if (!managerComment.trim()) {
      setError(true);

      openPopup(
        "Alert",
        "Please fill in Manager Comments before submitting",
        () => {}
      );
    } else {
      setError(false);
     
      const res = await submitDeviationApprovalData(
        PjpDayData,
        managerComment,
        pjpPlanOption,
        action,
      );

      if (res === "") {
        openPopup("Success", `Your data has been submitted`, () => {
          setManagerComment("");
          setError(false);
          fetchDeviationData();
        });
      } else if (res === "failed") {
        openPopup(
          "Error",
          "Something went wrong. Please try again after some time!",
          () => {}
        );
      }
    }
  };

  return (
    <div
      className="dev-card"
      style={{
        borderLeftColor: PjpDayData.textColor,
        borderLeftWidth: "4px",
        borderLeftStyle: "solid",
      }}
    >
      <div
        className="date-status"
        onClick={() => setShowDetails((prevState: any) => !prevState)}
      >
        <div className="date">
          <EventNoteIcon />
          {PjpDayData.date}
        </div>
        <div>
          {PjpDayData.PJPPlan.toLowerCase() !== "weekly off" &&
            PjpDayData.PJPPlan.toLowerCase() !== "leave" &&
            PjpDayData.PJPPlan.toLowerCase() !== "holiday" && (
              <div
                className="label"
                style={{
                  backgroundColor: `${PjpDayData.textColor}1A`,
                  color: PjpDayData.textColor,
                }}
              >
                {PjpDayData.PJPPlan}
              </div>
            )}
        </div>
      </div>

      <div onClick={() => setShowDetails((prevState: any) => !prevState)}>
        {(PjpDayData.PJPPlan.toLowerCase() === "weekly off" ||
          PjpDayData.PJPPlan.toLowerCase() === "leave" ||
          PjpDayData.PJPPlan.toLowerCase() === "holiday") && (
          <div
            className="label"
            style={{
              backgroundColor: `${PjpDayData.textColor}1A`,
              color: PjpDayData.textColor,
              width: "100%",
              marginTop: "1.5rem",
            }}
          >
            {PjpDayData.PJPPlan}
          </div>
        )}
      </div>

      {PjpDayData.PJPPlan.toLowerCase() !== "weekly off" &&
        PjpDayData.PJPPlan.toLowerCase() !== "leave" &&
        PjpDayData.PJPPlan.toLowerCase() !== "holiday" && (
          <div onClick={() => setShowDetails((prevState: any) => !prevState)}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "end",
              }}
            >
              <div className="details">
                <div>
                  {translate(TranslationEnum.deviation_approval, "Name")} :{" "}
                  {PjpDayData.userName || "N/A"}
                </div>
                <div>
                  {translate(TranslationEnum.deviation_approval, "DB Name")} :{" "}
                  {PjpDayData.dbName || "NA"}
                </div>
                <div>
                  {translate(TranslationEnum.deviation_approval, "Beat")} :{" "}
                  {PjpDayData.beat || "NA"}
                </div>
              </div>

              <div className="expand-details">
                {showDetails ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </div>
            </Box>

            {showDetails && (
              <div className="town-details">
                {PjpDayData.startTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={startTown}
                        alt="Start Town"
                        className="town-icon"
                      />
                      <span>Start Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.startTown}</span>
                  </div>
                )}

                {PjpDayData.workTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={workTown}
                        alt="Work Town"
                        className="town-icon"
                      />
                      <span>Work Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.workTown}</span>
                  </div>
                )}

                {PjpDayData.nhTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img src={nhTown} alt="NH Town" className="town-icon" />
                      <span>NH Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.nhTown}</span>
                  </div>
                )}

                {PjpDayData.meetingTown && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={meetingTown}
                        alt="Meeting Town"
                        className="town-icon"
                      />
                      <span>Meeting Town</span>
                    </span>
                    <span className="town-value">{PjpDayData.meetingTown}</span>
                  </div>
                )}

                {PjpDayData.nhExist && (
                  <div className="town-row">
                    <span className="town-label">
                      <img src={nhTown} alt="NH Exist" className="town-icon" />
                      <span>NH Exist</span>
                    </span>
                    <span className="town-value">{PjpDayData.nhExist}</span>
                  </div>
                )}

                {PjpDayData.routeCodeValid && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={nhTown}
                        alt="Route Code Exist"
                        className="town-icon"
                      />
                      <span>Route Code Exist</span>
                    </span>
                    <span className="town-value">
                      {PjpDayData.routeCodeValid}
                    </span>
                  </div>
                )}

                {PjpDayData.routeCodeNHValid && (
                  <div className="town-row">
                    <span className="town-label">
                      <img
                        src={nhTown}
                        alt="Route Code NH Exist"
                        className="town-icon"
                      />
                      <span>Route Code NH Exist</span>
                    </span>
                    <span className="town-value">
                      {PjpDayData.routeCodeNHValid}
                    </span>
                  </div>
                )}

                {PjpDayData.statusRemarks && (
                  <div className="town-row">
                    <span className="town-label">
                      <img src={nhTown} alt="Reason" className="town-icon" />
                      <span>Reason</span>
                    </span>
                    <span className="town-value">
                      {PjpDayData.statusRemarks}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

      <div className="deviation-manager-comment">
        <TextField
          id="outlined-multiline-static"
          label="Manager Comment"
          multiline
          rows={4}
          value={managerComment}
          onChange={onCommentChange}
          error={error}
          helperText={error ? "Manager Comment cannot be empty" : ""}
        />
      </div>


      <div className="deviation-button-container">
          <Button variant="contained" 
          onClick={() => handleApprove("reject")}
            >
          {translate(TranslationEnum.deviation_approval, "Decline")}
          </Button>
          <Button variant="contained" 
          onClick={() => handleApprove("approve")}
          >
          {translate(TranslationEnum.deviation_approval, "Approve")}
          </Button>
        </div>
    </div>
  );
};

export default DeviationDayCard;
